import React, { Component, Fragment } from 'react'
import Header from '../../components/Header/header'
import Sidebar from '../../components/Sidebar/Sidebar'
import { Grid, Content } from '../../components/Layout'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { cabinetProductsActions, incompatibilityAnalysisActions, productMapActions } from '../../actions'
import { RefreshIcon } from '../../components/icons'
import { ReloadButton } from '../../components/Form'
import ReturnPageButton from '../../components/ReturnPageButton'
import { pxToRem } from '../../utils'
import { SimpleLoader, WrapperLoader } from '../../components/loaders'
import CaptionArea from '../../components/Captions'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'
import { ProductMapModal } from '../../components/ProductModal'
import { color } from '../../utils'
import { DownloadButton } from '../../components/Form'
import { PdfIcon } from '../../components/icons'

const Container = styled.div`
  padding: 20px;
  background-color: #FFF;

  ul {
    padding: 0;
    margin: 0;
  }

  li{
    list-style-type: none;
    padding-bottom: 10px;
    border-bottom: 1px solid gray;
    margin-bottom: 30px;
  }

  li:last-child {
    border: none;
    margin: 0;
    padding: 0;
  }

  p {
    display: block;
    margin: 0;
  }
`

const Wrapper = styled.div`
  color: #5b666d;
  min-height: ${pxToRem(240)};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  div {
    text-align: center;
  }
  strong {
    font-size: ${pxToRem(14)};
    text-align: center;
  }
`

const LinkName = styled.a`
  color: ${color.secondary};
  -webkit-text-decoration: underline;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const WrapperDownload = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-left: 0;
    padding-right: 0;
  }
  span {
    font-weight: bold;
  }
`

class CabinetProducts extends Component {
  constructor(props) {
    super(props)
    const { id } = (props.router.match.params || {})
    this.state = {
      id,
      openProductMapModal: false
    }
  }

  componentDidMount() {
    const { id } = this.state
    this.props.fetchCabinetProducts(id)
  }

  toggleModal = () => {
    this.setState(state => ({
      openProductMapModal: !state.openProductMapModal
    }))
  }

  render() {
    const {
      menuItems = [],
      router,
      cabinet,
      fetch_errors,
      fetchCabinetProducts,
      loading,
      areaId,
      fetchDownloadPdf,
      loadingDownload,
      accessToken
    } = this.props
    const { name, cabinet_products } = cabinet
    const { id } = this.state

    return (
      <Fragment>
        <ProductMapModal
          open={this.state.openProductMapModal}
          closeModal={this.toggleModal}
        />
        <Grid>
        <Header router={router} />
          {(accessToken) && <Sidebar menuItems={menuItems} router={router} />}
          <Content>
            {loading ? (
              <WrapperLoader>
                <SimpleLoader />
              </WrapperLoader>
            ) : (
              !fetch_errors.cabinet ? (
                <Fragment>
                  <ContentHeader
                    title={`Armário: ${name}`}
                    last_update={dateToBrFormat(new Date(cabinet.updated_at))}
                  >
                  </ContentHeader>
                  <WrapperDownload>
                    <CaptionArea />
                    <DownloadButton
                      loading={loadingDownload}
                      onClick={e => { fetchDownloadPdf(areaId, id) }}
                    >
                      <PdfIcon color="#FFF" />
                      <span>Exportar para PDF</span>
                    </DownloadButton>
                  </WrapperDownload>
                  {cabinet_products.length > 0 ? (
                    <Fragment>
                      <Container>
                        <ul>
                          {cabinet_products.map(product =>
                            <li>
                              <p><strong>Nome Produto:</strong> <LinkName onClick={() => {
                                this.props.fetchProductMap(product.product_id)
                                this.toggleModal()
                              }}>{product.product_name}</LinkName></p>
                              <p><strong>Fornecedor:</strong> {product.product_provider}</p>
                              {
                                product.supervisories_code &&
                                <p><strong>Órgão(s) Fiscalizador(es):</strong> {product.supervisories_code}</p>
                              }
                            </li>
                          )}
                        </ul>
                      </Container>
                    </Fragment>
                  ) : (
                    <p>Não há produtos neste armário</p>
                  )}
                </Fragment>
              ) : (
                <Wrapper>
                  <strong>Falha ao carregar as informações deste armário.</strong>

                  <ReloadButton
                    onClick={() => {
                      fetchCabinetProducts(id)
                    }}
                  >
                    Tentar novamente{' '}
                    <RefreshIcon />
                  </ReloadButton>

                  <ReturnPageButton
                    pathname="/analise-de-incompatibilidade"
                  >
                    Voltar a página anterior
                  </ReturnPageButton>
                </Wrapper>
              )
            )}
          </Content>
        </Grid>
      </Fragment >
    )
  }
}

const mapStateToProps = state => ({
  loading: state.cabinetProducts.loading.cabinet,
  cabinet: state.cabinetProducts.cabinet,
  fetch_errors: state.cabinetProducts.fetch_errors,
  areaId: state.auth.areaId,
  loadingDownload: state.incompatibilityAnalysis.loading.download,
  accessToken: state.headers.accessToken
})

const mapDispatchToProps = dispatch => {
  return {
    fetchCabinetProducts: (id) => {
      dispatch(cabinetProductsActions.fetchCabinetProducts(id))
    },
    fetchProductMap: id => {
      dispatch(productMapActions.fetchProductMap(id))
    },
    fetchDownloadPdf: (areaId, cabinetId) => {
      dispatch(incompatibilityAnalysisActions.fetchDownloadPdf(areaId, cabinetId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CabinetProducts)



// WEBPACK FOOTER //
// ./src/containers/CabinetProducts/CabProd.js